import React from "react";

import "./NavigationItems.css";
import NavigationItem from "./NavigationItem/NavigationItem";

const navigationItems = props => (
  <ul className="NavigationItems">
    <NavigationItem link="#about-us" exact>
      O NAS
    </NavigationItem>
    <NavigationItem link="#services">USŁUGI</NavigationItem>
    <NavigationItem link="#galery">GALERIA</NavigationItem>
    <NavigationItem link="#contact">KONTAKT</NavigationItem>
  </ul>
);

export default navigationItems;



// WEBPACK FOOTER //
// ./src/components/Cloackroom/Navigation/NavigationItems/NavigationItems.js